import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=612a31b7&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"
import style0 from "./rate.vue?vue&type=style&index=0&id=612a31b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a31b7",
  null
  
)

export default component.exports